import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormFeedback, Input, Label, Row, Col, Button, Card, CardBody, Container } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

import { ToastContainer } from "react-toastify";


import { 
    getStudentByUuid as onGetStudentByUuid,
     addNewStudent as onAddNewStudent,
    updateStudent as onUpdateStudent,

} from "../../store/actions";
//import { createOrUpdateStudent } from "../api/student.api";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const CreateOrEditStudent = () => {

    //meta title
  document.title = "Étudiant | CinzanEdu";


  const { uid } = useParams();
  const isEdit = !!uid;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { student, loading } = useSelector(state => state.studentReducer);

  useEffect(() => {
    if (uid) dispatch(onGetStudentByUuid(uid));
  }, [uid, dispatch]);

  console.log("DANS LE COMPO: ", student);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
        id: student?.id || "",
      first_name: student?.first_name || "",
      last_name: student?.last_name || "",
      sex: student?.sex || "",
      phone: student?.phone || "",
      email: student?.email || "",
      nationality: student?.nationality || "",
      cnou_registration_number: student?.cnou_registration_number || "",
      baccalaureate_year: student?.baccalaureate_year || "",
      baccalaureate_series: student?.baccalaureate_series || "",
      baccalaureate_mention: student?.baccalaureate_mention || 0,
      father_firstname: student?.father_firstname || "",
      mother_firstname: student?.mother_firstname || "",
      mother_lastname: student?.mother_lastname || "",
      tutor_name: student?.tutor_name || "",
      tutor_phone: student?.tutor_phone || "",
      family_situation: student?.family_situation || "",
      birthdate: student?.birthdate || "",
      birthplace: student?.birthplace || "",
      residence_place: student?.residence_place || "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Prénom requis"),
      last_name: Yup.string().required("Nom requis"),
      email: Yup.string().email("Email invalide"),
      birthdate: Yup.date().required("Date de naissance requise"),
    }),
    onSubmit: async (values) => {
        // Préparer les champs communs pour Student
        const studentData = {
            id: values.id,
            first_name: values.first_name,
            last_name: values.last_name,
            sex: values.sex,
            phone: values.phone,
            email: values.email,
            nationality: values.nationality,
            cnou_registration_number: values.cnou_registration_number,
            baccalaureate_year: values.baccalaureate_year,
            baccalaureate_series: values.baccalaureate_series,
            baccalaureate_mention: values.baccalaureate_mention,
            father_firstname: values.father_firstname,
            mother_firstname: values.mother_firstname,
            mother_lastname: values.mother_lastname,
            tutor_name: values.tutor_name,
            tutor_phone: values.tutor_phone,
            family_situation: values.family_situation,
            birthdate: values.birthdate,
            birthplace: values.birthplace,
            residence_place: values.residence_place,
        };


        try {
            if (isEdit) {
                // Ajouter les champs nécessaires pour l'édition
                //studentData.id = values.id;
                //studentData.uid = values.uid;

                await dispatch(onUpdateStudent(studentData));
                    
            } else {
             await dispatch(onAddNewStudent(studentData));
              
            }

            // Réinitialiser le formulaire
            validation.resetForm();

            

           

            // Rediriger vers la liste des étudiants
            navigate("/students");
        } catch (error) {
            console.error("Erreur lors de l'enregistrement :", error);
           
        }
        }

    });

  if (loading) return <p>Chargement...</p>;

  return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Étudiant" breadcrumbItem={uid ? "Modifier l'étudiant" : "Créer un nouvel étudiant"} />

                    <Card>
                    <CardBody>
                        <h3>{uid ? "Modifier l'étudiant" : "Créer un nouvel étudiant"}</h3>
                        <Form onSubmit={validation.handleSubmit}>
                        <Row>
                            <Col md={6}>
                            <Label>Prénom</Label>
                            <Input
                                name="first_name"
                                value={validation.values.first_name}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.first_name && !!validation.errors.first_name}
                            />
                            <FormFeedback>{validation.errors.first_name}</FormFeedback>
                            </Col>
                            <Col md={6}>
                            <Label>Nom</Label>
                            <Input
                                name="last_name"
                                value={validation.values.last_name}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.last_name && !!validation.errors.last_name}
                            />
                            <FormFeedback>{validation.errors.last_name}</FormFeedback>
                            </Col>
                            <Col md={6}>
                            <Label>Sexe</Label>
                            <Input
                                type="select"
                                name="sex"
                                value={validation.values.sex}
                                onChange={validation.handleChange}
                            >
                                <option value="">--Choisir--</option>
                                <option value="M">Masculin</option>
                                <option value="F">Féminin</option>
                            </Input>
                            </Col>
                            <Col md={6}>
                            <Label>Email</Label>
                            <Input
                                name="email"
                                type="email"
                                value={validation.values.email}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.email && !!validation.errors.email}
                            />
                            <FormFeedback>{validation.errors.email}</FormFeedback>
                            </Col>
                            <Col md={6}>
                            <Label>Téléphone</Label>
                            <Input
                                name="phone"
                                value={validation.values.phone}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6}>
                            <Label>Nationalité</Label>
                            <Input
                                name="nationality"
                                value={validation.values.nationality}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            
                            
                            <Col md={6}>
                            <Label>Numéro CNOU</Label>
                            <Input
                                name="cnou_registration_number"
                                value={validation.values.cnou_registration_number}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Année Bac</Label>
                            <Input
                                type="number"
                                name="baccalaureate_year"
                                value={validation.values.baccalaureate_year}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Série Bac</Label>
                            <Input
                                name="baccalaureate_series"
                                value={validation.values.baccalaureate_series}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Mention Bac</Label>
                            <Input
                                type="number"
                                name="baccalaureate_mention"
                                value={validation.values.baccalaureate_mention}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Prénom père</Label>
                            <Input
                                name="father_firstname"
                                value={validation.values.father_firstname}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Prénom mère</Label>
                            <Input
                                name="mother_firstname"
                                value={validation.values.mother_firstname}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={4}>
                            <Label>Nom mère</Label>
                            <Input
                                name="mother_lastname"
                                value={validation.values.mother_lastname}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6}>
                            <Label>Nom Tuteur</Label>
                            <Input
                                name="tutor_name"
                                value={validation.values.tutor_name}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6}>
                            <Label>Téléphone Tuteur</Label>
                            <Input
                                name="tutor_phone"
                                value={validation.values.tutor_phone}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6}>
                            <Label>Situation familiale</Label>
                            <Input
                                name="family_situation"
                                value={validation.values.family_situation}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6}>
                            <Label>Date de naissance</Label>
                            <Input
                                type="date"
                                name="birthdate"
                                value={validation.values.birthdate}
                                onChange={validation.handleChange}
                                invalid={validation.touched.birthdate && !!validation.errors.birthdate}
                            />
                            <FormFeedback>{validation.errors.birthdate}</FormFeedback>
                            </Col>
                            <Col md={6} class="mt-3">
                            <Label>Lieu de naissance</Label>
                            <Input
                                name="birthplace"
                                value={validation.values.birthplace}
                                onChange={validation.handleChange}
                            />
                            </Col>
                            <Col md={6} class="mt-3">
                            <Label>Lieu de résidence</Label>
                            <Input
                                name="residence_place"
                                value={validation.values.residence_place}
                                onChange={validation.handleChange}
                            />
                            </Col>
                        </Row>

                        <div className="mt-4 d-flex gap-2">
                            
                            <Button color="secondary" type="button" onClick={() => navigate("/students")}>Annuler</Button>
                            <Button color="primary" type="submit">{uid ? "Mettre à jour" : "Créer"}</Button>
                        </div>
                        </Form>
                    </CardBody>
                    </Card>
                </Container>
            </div>
        </React.Fragment >
  );
};

export default CreateOrEditStudent;
